import React from 'react';

function TabLayout({ children }) {
  return (
    <div
      className="!scrollbar-hide pt-[8px] bg-[#F7F7F7] h-[100%] 
    inputFormStyle overflow-auto
    [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']"
      style={{ height: 'calc(100vh - 100px)' }}
    >
      {children}
    </div>
  );
}

export default TabLayout;
